/**
 * Created by charnjeetelectrovese@gmail.com on 5/1/2020.
 */
import {serviceGetAppSettings, serviceUpdateGeoFence,serviceUpdatePolicies, serviceGetThemeByDomain} from "../services/AppSettings.service";
import EventEmitter from "../libs/Events.utils";

export const APP_SETTINGS_INIT = 'APP_SETTINGS_INIT';
export const APP_SETTINGS_DONE = 'APP_SETTINGS_DONE';
export const APP_SETTINGS_UPDATE_GEOFENCE = 'APP_SETTINGS_UPDATE_GEOFENCE';
export const APP_SETTINGS_CHANGE_THEME = 'APP_SETTINGS_CHANGE_THEME';
export const APP_SETTINGS_UPDATE_POLICIES = 'APP_SETTINGS_UPDATE_POLICIES';
export const APP_SETTINGS_THEME_BY_DOMAIN = 'APP_SETTINGS_THEME_BY_DOMAIN';

export function actionGetThemeByDomain(customDomain) {
    return (dispatch) => {
        const storedTheme = localStorage.getItem('domainTheme');
        if (storedTheme) {
            try {
                const parsedTheme = JSON.parse(storedTheme);
                dispatch({ type: APP_SETTINGS_THEME_BY_DOMAIN, payload: parsedTheme });
                const favIcon = parsedTheme.fav_icon || parsedTheme.theme?.fav_icon;
                if (favIcon) {
                    let link = document.querySelector("link[rel~='icon']");
                    if (!link) {
                        link = document.createElement('link');
                        link.rel = 'icon';
                        document.getElementsByTagName('head')[0].appendChild(link);
                    }
                    link.href = favIcon;
                }
            } catch (e) {}
        }

        // 2. call api -> update ui theme and localstorage
        serviceGetThemeByDomain().then((data) => {
            console.log("THEME API RESPONSE:", data);
            if (!data.error) {
                const clientTheme = data.data?.theme || {};
                const themeAssets = clientTheme.theme || {};
                const themeData = {
                    ...clientTheme,
                    ...themeAssets,
                    theme: themeAssets,
                };
                console.log("EXTRACTED THEME DATA:", themeData);
                localStorage.setItem('domainTheme', JSON.stringify(themeData));
                dispatch({ type: APP_SETTINGS_THEME_BY_DOMAIN, payload: themeData });
                // Also update favicon dynamically
                const favIcon = themeData.fav_icon || themeData.theme?.fav_icon;
                if (favIcon) {
                    let link = document.querySelector("link[rel~='icon']");
                    if (!link) {
                        link = document.createElement('link');
                        link.rel = 'icon';
                        document.getElementsByTagName('head')[0].appendChild(link);
                    }
                    link.href = favIcon;
                }
            } else {
                console.error("THEME API ERROR:", data.message);
            }
        });
    };
}

export function actionGetAppSettings(data) {
    const req = serviceGetAppSettings({});
    return (dispatch) => {
        dispatch({ type: APP_SETTINGS_INIT, payload: {} });
        req.then((data) => {
            if (!data.error) {
                const tempData = data.data;
                dispatch({ type: APP_SETTINGS_DONE, payload: tempData });
            }
        });
    };
    // return ({type: AUTH_USER, payload: data});
}


export function actionUpdateGeoFence(data) {
    const request = serviceUpdateGeoFence({ polygon: data } )
    return (dispatch) => {
        dispatch({ type: APP_SETTINGS_UPDATE_GEOFENCE, payload: data })
    }
}

export function actionChangeTheme(theme) {
    return (dispatch) => {
        localStorage.setItem('theme', theme);
        dispatch({type: APP_SETTINGS_CHANGE_THEME, payload: theme});
    }
}

export function actionUpdatePolicies(name, value) {
    const request = serviceUpdatePolicies({ name, value } ).then((res) => {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {error: 'Saved Successfully', type: 'success'});
    });
    return (dispatch) => {
        dispatch({ type: APP_SETTINGS_UPDATE_POLICIES, payload: {name, value} })
    }
}
